"use client";
import React, { FC, ChangeEvent, KeyboardEvent } from "react";
import Image from "next/image";
import { useState } from "react";
import Head from "next/head";

class Pts24Answer {
  constructor(answer: string, className: string = "") {
    this.className = className;
    this.Answer = answer;
  }

  Answer: string;
  className: string;
}

interface IAnswerCollection {
  Answers: Pts24Answer[];
}

const AnswerComponent: FC<IAnswerCollection> = (props) => {
  const listItem = props.Answers.map((a) => (
    <li key={a.Answer} className={a.className}>
      {a.Answer}
    </li>
  ));
  return (
    <ul className="max-w-md space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
      {listItem}
    </ul>
  );
};

export default function Page() {
  const [strcards, setStrCards] = useState("2 4 5 10");
  const initAnswer: Pts24Answer[] = [];
  const [answer, setAnswer] = useState(initAnswer);
  const onTexFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
    setStrCards(e.target.value);
  };

  const noanswer = [new Pts24Answer("找不到凑成24的方法", "text-danger")];

  const onTextFieldKeydown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.altKey === false && e.key === "Enter") {
      verifycards();
    }
  };
  const getcards = () => {
    var ncards = strcards
      .split(" ")
      .filter((v) => v.length > 0)
      .map((v, i) => {
        return Number(v.trim());
      })
      .filter((n) => Number.isNaN(n) === false);
    return ncards;
  };

  const verifycards = () => {
    var ncards = getcards();
    const canCalc = showPoint24(ncards);
    const nums: string = ncards
      .map((v, i) => v.toString())
      .reduce((v, c) => v + " " + c);
    const tip: Pts24Answer = new Pts24Answer(
      canCalc ? "这些数字可以凑成24" : "无法将这些数字凑成24",
      canCalc ? "text-success" : "text-danger"
    );
    const myanswer: Pts24Answer[] = [
      new Pts24Answer("您输入的数字分别是：" + nums),
      tip,
    ];
    setAnswer(myanswer);
  };
  const showAnswer = () => {
    var ncards = getcards();

    global_answer = [];
    const canCalc = showPoint24(ncards);
    if (canCalc === false) {
      setAnswer(noanswer);
    } else {
      const reversed = global_answer.reverse();
      setAnswer(reversed);
      global_answer = [];
    }
  };
  const clearAnswer = () => {
    setAnswer([]);
  };
  const showTips = () => {
    var ncards = getcards();

    global_answer = [];
    const canCalc = showPoint24(ncards);
    if (canCalc === false) {
      setAnswer(noanswer);
    } else {
      setAnswer([global_answer[0]]);
      global_answer = [];
    }
  };

  const randomNums = () => {
    let cards = randomcards();
    while (!showPoint24(cards)) {
      cards = randomcards();
    }

    const strcards = cards
      .map((v) => v.toString())
      .reduce((p, c, i) => p + " " + c);
    setStrCards(strcards);
    setAnswer([]);
  };
  return (
    <>
      <Head>
        <title>24点游戏</title>
      </Head>
      <div className="max-w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
        <Image
          src="/images/tf24.jpg"
          className="card-img-top"
          alt="..."
          width={1294}
          height={450}
        />
        <div className="p-5">
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            24 点
          </h5>
          <div className="mb-3 font-normal text-gray-700 dark:text-gray-400">
            <p>
              24点游戏（在香港也称“合廿四”）是一种使用扑克牌来进行的益智类游戏，游戏内容是：从一副扑克牌中抽去大小王，在剩下52张中任意抽取4张牌，把牌面上的数（A代表1）运用加、减、乘、除和括号进行运算得出24。每张牌都必须使用一次，但不能重复使用。在不同版本中，对J、Q、和K的处理有些差异。一个常见的版本是把J、Q、和K去除，或当成10；还有一个版本是把J表示11，Q表示12，K代表13。
            </p>
            <p>
              有些组合有多种算法，例如2，4，6，Q四张牌可用 2 + 4 + 6 + 12 = 24
              或 4×6 ÷ 2 + 12 = 24 或 12 ÷ 4×(6 + 2) =
              24等来求解。也有些组合算不出24，如1、1、1、1 和 6、7、8、8等组合。
            </p>
            <p>
              这个小程序可以作为24点游戏的辅助，帮助你快速了解你的牌能否达成24点。
            </p>
          </div>
        </div>
        <div className="mx-2">
          <label
            htmlFor="tfvalue"
            className="p-1 mt-5 text-base text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400"
          >
            请输入4个数字（以空格分隔，例如：
            <span className="text-pink">2 4 5 10</span>
            ），如果你输入的不是数字，不是数字的部分会被自动忽略。
          </label>
          <input
            type="text"
            name="tf_zip"
            className="w-11/12 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 my-6 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
            id="tfvalue"
            placeholder="2 4 5 10"
            value={strcards}
            onChange={onTexFieldChange}
            onKeyDown={onTextFieldKeydown}
          />
          <div className="space-x-2">
            <button
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              onClick={verifycards}
            >
              查看是否能够凑成24
            </button>
            <button
              className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
              onClick={showTips}
            >
              查看提示
            </button>
            <button
              className="text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              onClick={showAnswer}
            >
              查看答案
            </button>
            <button
              className="focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900"
              onClick={clearAnswer}
            >
              清空答案
            </button>
            <button
              className="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
              onClick={randomNums}
            >
              随机生成
            </button>
          </div>
          <div className="answer">
            <AnswerComponent Answers={answer} />
          </div>
        </div>
      </div>
    </>
  );
}

const epsilon = 0.001;
var global_answer: Pts24Answer[] = [];

function generrateHow(a: number, op: string, b: number, num: number) {
  return a.toString() + op + b.toString() + "=" + num.toString();
}

function randomcards() {
  let cards: number[] = [];
  for (let i = 0; i < 4; i++) {
    cards.push(Math.floor(Math.random() * 13) + 1);
  }
  return cards;
}

function generatePossibleEntity(a: number, b: number) {
  let res: Pts24Method[] = [
    { how: generrateHow(a, "+", b, a + b), num: a + b },
    { how: generrateHow(a, "×", b, a * b), num: a * b },
  ];
  if (a >= b) {
    res.push({ how: generrateHow(a, "-", b, a - b), num: a - b });
  } else {
    res.push({ how: generrateHow(b, "-", a, b - a), num: b - a });
  }
  if (a !== 0) {
    res.push({ how: generrateHow(b, "÷", a, b / a), num: b / a });
  }
  if (b !== 0) {
    res.push({ how: generrateHow(a, "÷", b, a / b), num: a / b });
  }

  return res.filter((v, i) => Number.isInteger(v.num));
}

interface Pts24Method {
  how: string;
  num: number;
}
function showPoint24(cards: number[]) {
  if (cards.length === 1) {
    return Math.abs(cards[0] - 24) <= epsilon;
  }

  for (let i = 0; i < cards.length; i++) {
    for (let j = i + 1; j < cards.length; j++) {
      // create new list with remaining numbers
      const newCards: number[] = [];
      for (let k = 0; k < cards.length; k++) {
        if (k !== i && k !== j) {
          newCards.push(cards[k]);
        }
      }

      // for any 2 numbers perform every operation
      let results = generatePossibleEntity(cards[i], cards[j]);

      for (let resIdx = 0; resIdx < results.length; ++resIdx) {
        // Push the new result in the list
        newCards.push(results[resIdx].num);

        // Check if using this new list we can obtain the result 24.
        if (showPoint24(newCards)) {
          global_answer.push(new Pts24Answer(results[resIdx].how));
          return true;
        }

        // Backtrack: remove the result from the list.
        newCards.pop();
        global_answer.pop();
      }
    }
  }
  return false;
}
